import i18next from 'i18next';

const localStorage = typeof window === 'undefined' ? undefined : window.localStorage;
const PREFERRED_LOCALE_KEY = 'locale';
const isSEDomain = typeof window !== 'undefined' && window.location.host.includes('.se');

const DEFAULT_LOCALE = isSEDomain ? 'sv' : import.meta.env.VITE_DEFAULT_LOCALE ?? 'en';
const FALLBACK_LOCALE = import.meta.env.VITE_FALLBACK_LOCALE ?? DEFAULT_LOCALE;

function getPreffered(): string {
  return (
    localStorage?.getItem(PREFERRED_LOCALE_KEY) ??
    (typeof navigator !== 'undefined' ? navigator.language : DEFAULT_LOCALE)
  );
}

function getFallback() {
  return FALLBACK_LOCALE;
}

function getCurrent(): string {
  const storedLanguage = i18next.language.split('-')[0];
  return localStorage?.getItem(PREFERRED_LOCALE_KEY) ?? storedLanguage;
}

function setCurrent(locale: string): void {
  if (typeof window !== 'undefined') {
    localStorage?.setItem(PREFERRED_LOCALE_KEY, locale);
  }

  i18next.changeLanguage(locale);
}

function getCurrentHierarchy(): string | string[] {
  const locale = getCurrent();
  return locale === FALLBACK_LOCALE ? locale : [locale, FALLBACK_LOCALE];
}

export default {
  getPreffered,
  getCurrent,
  setCurrent,
  getCurrentHierarchy,
  getFallback,
};
